// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll[data-v-7b4ca4ba] {\n  -ms-overflow-style: none;\n  overflow: scroll;\n  scrollbar-width: none;\n}\n.scroll[data-v-7b4ca4ba]::-webkit-scrollbar {\n  display: none;\n}\nbutton[data-v-7b4ca4ba] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
